module.exports = __webpack_public_path__ + "fca6fa588cc99d753f9f955859969cdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ms-bg-5.jpg
// module id = 147
// module chunks = 0